import React, { useEffect, useState } from "react";
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon,ChevronRightIcon } from '@heroicons/react/solid'
import {
  Autoplay,
  Scrollbar,
  Navigation,
  Pagination,
  Controller,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import type { Product } from "~/types";

import { ProductCardCarousel } from "../../commerce/product-card-carousel";

interface EmblaCarouselProps {
  productData: Product[];
}

export const EmblaCarouselProducts = (props: EmblaCarouselProps) => {
  const { productData } = props;
  const [swiper, setSwiper] = useState();
  const prevRef = React.useRef();
  const nextRef = React.useRef();

  useEffect(() => {
    if (swiper) {
      // console.log("Swiper instance:", swiper);
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);
  return (
    <section className="h-full w-full">
      <div className="relative">
        <div>
          {/* <button ref={prevRef}>prev</button> */}
        
          <Swiper
            containerModifierClass="home-product-slider slider-products"
            spaceBetween={30}
            slidesPerView={2.5}
            className="!overflow-visible"
            //navigation={{ nextEl: ".arrow-left", prevEl: ".arrow-right" }}
            pagination={{
              clickable: true,
            }}
            navigation={{
              prevEl: prevRef?.current,
              nextEl: nextRef?.current,
            }}
            updateOnWindowResize
            observer
            observeParents
            initialSlide={0}
            onSwiper={setSwiper}
            breakpoints={{
              0: {
                slidesPerView: 1.2,
                spaceBetween: 30,
              },
              640: {
                slidesPerView: 2.5,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 2.5,
                spaceBetween: 30,
              },
              1280: {
                slidesPerView: 2.5,
                spaceBetween: 30,
              },
            }}
            // watchSlidesProgress
            // grabCursor
            // freeMode
            modules={[Navigation, Scrollbar, Autoplay, Pagination, Controller]}
          >
            <button className="swiper-nav swiper-left" ref={prevRef}>
            <ChevronLeftIcon width="35px"/>
            </button>
            {productData.map((product) => (
              <SwiperSlide
                className="relative flex justify-center"
                key={product.id}
              >
                <ProductCardCarousel key={product.id} product={product} />
              </SwiperSlide>
            ))}
            <button className="swiper-nav swiper-right" ref={nextRef}>
              <ChevronRightIcon width="35px"/>
              </button>
          </Swiper>
          {/* <button ref={nextRef}>next</button> */}
          
        
        </div>
        {/* <button className="arrow-left arrow">Prev</button>
        <button className="arrow-right arrow">next</button> */}
      </div>
    </section>
  );
};
